/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, companyName: NonNullable<unknown> }} Registration_Invitationmessage1Inputs */

const en_registration_invitationmessage1 = /** @type {(inputs: Registration_Invitationmessage1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You've been invited by ${i?.name} to join the ${i?.companyName} platform.`)
};

/**
* | output |
* | --- |
* | "You've been invited by {name} to join the {companyName} platform." |
*
* @param {Registration_Invitationmessage1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const registration_invitationmessage1 = /** @type {((inputs: Registration_Invitationmessage1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registration_Invitationmessage1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_registration_invitationmessage1(inputs)
});
export { registration_invitationmessage1 as "registration_invitationMessage" }